module.exports = __webpack_public_path__ + "static/img/no-pay.629936f.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/order-img/no-pay.png
// module id = BF/o
// module chunks = 17